const svgContext = require.context(
  '!!@svgr/webpack!../assets/images',
  true,
  /\.svg$/,
);

const svgComponents: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {};

svgContext.keys().forEach(key => {
  const cleanKey = key.replace('./', '');
  svgComponents[cleanKey] = svgContext(key).default;
});

export const getSvgComponent = (fileName: string) => {
  return svgComponents[fileName] ?? null;
};
